export default (style, newSourceName) => {
    style.layers.forEach((layer) => {
        layer.source = newSourceName;
    });
    Object.keys(style.sources).forEach((sourceName) =>{
        style.sources[newSourceName] = style.sources[sourceName];
        delete style.sources[sourceName];
    });
};



// WEBPACK FOOTER //
// ./map/tier/sourceNameReplacer.js